module.exports = __webpack_public_path__ + "3c0d525c68cfce013f84a18efbf7fe08.MP3";